import { BannerConfig, ContactSettings } from './types';

export const defaultBannerConfig: BannerConfig = {
    enabled: true,
    message: 'To inquire about being an EKC Collegiate Student Ambassador, ',
    secondaryMessage: 'Apply For An EKC Scholarship!',
    linkGapPx: 50,
    link: { type: 'modal', label: 'Click Here', href: '/grow-with-google' },
    secondaryLink: { type: 'url', label: 'Click Here', href: '/grow-with-google' },
};

export const defaultContactSettings: ContactSettings = {
    notificationEmail: null,
    storeSubmissions: true,
};
